import React, { useState, useEffect } from 'react';
import { Modal, ModalHeader, ModalBody, FormGroup, Label, Input, Button, Form } from 'reactstrap';
import { ButtonInsert, ButtonDelete } from '../Buttons/Buttons';
import SeguimientoBoletaService from '../../axios_services/seguimientoboleta.service';
import "./ModalCrearUsuario.css";

function ModalSeguimientoBoleta({ isOpen, onClose, onSave, personal, supervisores, initialSupervisorId = '', initialGestorId = '', initialDnis = [], perfilId }) {
    const [supervisorId, setSupervisorId] = useState('');
    const [gestorId, setGestorId] = useState('');
    const [dnisRegistrar, setDnisRegistrar] = useState([]);
    const [deletedIds, setDeletedIds] = useState([]);
    const [dnisDisponibles, setDnisDisponibles] = useState([]);
    const [loading, setLoading] = useState(false);

    const perfilIdNum = Number(perfilId);
    const isAnalista = [4, 27].includes(perfilIdNum);
    const isEditor = [3, 4, 6, 8, 23, 27].includes(perfilIdNum);
    const canEditDni = [3, 4, 8, 27].includes(perfilIdNum);
    const canEditRevision = [6, 8, 23].includes(perfilIdNum);

    useEffect(() => {
        if (isOpen) {
            setSupervisorId(initialSupervisorId.toString());
            setGestorId(initialGestorId.toString());
            setDeletedIds([]);

            if (initialDnis && initialDnis.length > 0) {
                setDnisRegistrar(initialDnis.map(d => ({
                    id: d.seguimiento_boleta_id,
                    value: d.dni,
                    isNew: Number(d.canal_captacion_id) === 1,
                    revision_subgerencia: d.revision_subgerencia || 0
                })));
            } else {
                setDnisRegistrar([{ value: '', isNew: false, revision_subgerencia: 0 }]);
            }
        }
    }, [isOpen, initialSupervisorId, initialGestorId, initialDnis]);

    useEffect(() => {
        if (gestorId) {
            fetchDnis(gestorId);
        } else {
            setDnisDisponibles([]);
        }
    }, [gestorId]);

    const fetchDnis = async (id) => {
        try {
            const data = await SeguimientoBoletaService.getDnisDisponibles(id);
            setDnisDisponibles(data);
        } catch (error) {
            console.error("Error fetching DNIs:", error);
        }
    };

    const handleSave = async () => {
        const validDnis = dnisRegistrar.map(d => d.value).filter(v => v.trim() !== '');
        if (!supervisorId || !gestorId || (validDnis.length === 0 && deletedIds.length === 0)) {
            alert('Por favor complete todos los campos y agregue al menos un DNI');
            return;
        }

        setLoading(true);
        try {
            await onSave({
                supervisor_id: supervisorId,
                gestor_id: gestorId,
                dnis: dnisRegistrar.filter(d => d.value.trim() !== ''),
                deletedIds: deletedIds
            });
            onClose();
        } catch (error) {
            console.error("Error saving:", error);
        } finally {
            setLoading(false);
        }
    };

    const addDniRow = () => {
        setDnisRegistrar([...dnisRegistrar, { value: '', isNew: false, revision_subgerencia: 0 }]);
    };

    const removeDniRow = (index) => {
        const rowToRemove = dnisRegistrar[index];
        if (rowToRemove.id) {
            setDeletedIds(prev => [...prev, rowToRemove.id]);
        }
        setDnisRegistrar(dnisRegistrar.filter((_, i) => i !== index));
    };

    const handleDniChange = (index, field, value) => {
        const newDnis = [...dnisRegistrar];
        newDnis[index][field] = value;

        if (field === 'isNew' && value === true) {
            newDnis[index].value = '';
        }

        setDnisRegistrar(newDnis);
    };

    const gestorActual = personal.find(p => Number(p.usuario_id) === Number(gestorId));
    const title = gestorActual ? gestorActual.nombre_completo_usuario.toUpperCase() : (initialDnis && initialDnis.length > 0 ? 'EDITAR SEGUIMIENTO' : 'NUEVO SEGUIMIENTO');

    const rowGridStyle = {
        display: 'grid',
        gridTemplateColumns: (perfilIdNum === 3 || isAnalista) ? '1fr 45px' : '1fr 130px 45px',
        gap: '15px',
        alignItems: 'center',
        padding: '0 5px'
    };

    const headerStyle = {
        ...rowGridStyle,
        marginBottom: '10px',
        fontSize: '13px',
        color: '#0549a7',
        fontWeight: 'normal',
        textTransform: 'none'
    };

    const commonInputStyle = {
        fontSize: '13px',
        padding: '8px 12px',
        height: '42px',
        width: '100%'
    };

    return (
        <Modal isOpen={isOpen} className="custom-modal" backdrop="static" size="lg">
            <ModalHeader className="modal-header">
                <div className="titulo">
                    <h1>{title}</h1>
                    <Button className="close-btn" onClick={onClose}>X</Button>
                </div>
            </ModalHeader>
            <div className="modal-body-footer">
                <ModalBody className="modal-body">
                    <Form onSubmit={(e) => e.preventDefault()}>
                        <FormGroup>
                            <div style={{ display: 'flex', justifyContent: 'flex-end', width: '100%', marginBottom: '1.5rem' }}>
                                {canEditDni && <ButtonInsert onClick={addDniRow} />}
                            </div>

                            <div style={headerStyle}>
                                <Label style={{ margin: 0, color: 'inherit', fontWeight: 'inherit', fontSize: 'inherit' }}>Prospecto</Label>
                                {(!isAnalista && perfilIdNum !== 3) && (
                                    <Label style={{ margin: 0, color: 'inherit', fontWeight: 'inherit', fontSize: 'inherit' }}>Revisión</Label>
                                )}
                                <div></div>
                            </div>

                            <div style={{ maxHeight: '450px', overflowY: 'auto', overflowX: 'hidden' }}>
                                {dnisRegistrar.map((dniRow, index) => (
                                    <div key={index} style={{ ...rowGridStyle, marginBottom: '18px' }}>
                                        <div style={{ minWidth: 0 }}>
                                            {!dniRow.isNew ? (
                                                <div style={{ width: '100%' }}>
                                                    <Input
                                                        type="select"
                                                        className="form-control"
                                                        style={commonInputStyle}
                                                        value={dniRow.value}
                                                        onChange={(e) => {
                                                            const val = e.target.value;
                                                            if (val === 'CAMPO') {
                                                                handleDniChange(index, 'isNew', true);
                                                            } else {
                                                                handleDniChange(index, 'value', val);
                                                            }
                                                        }}
                                                        disabled={!gestorId || !canEditDni}
                                                    >
                                                        <option value="">Seleccione...</option>
                                                        <option value="CAMPO">CAMPO</option>
                                                        {dnisDisponibles.map((d) => (
                                                            <option key={d.dni} value={d.dni}>
                                                                {d.dni}
                                                            </option>
                                                        ))}
                                                    </Input>
                                                </div>
                                            ) : (
                                                <div style={{ display: 'flex', gap: '8px', width: '100%', alignItems: 'center' }}>
                                                    <Input
                                                        type="select"
                                                        className="form-control"
                                                        style={{ ...commonInputStyle, width: '95px', flexShrink: 0 }}
                                                        value="CAMPO"
                                                        onChange={(e) => {
                                                            if (e.target.value !== 'CAMPO') {
                                                                handleDniChange(index, 'isNew', false);
                                                                handleDniChange(index, 'value', '');
                                                            }
                                                        }}
                                                        disabled={!canEditDni}
                                                    >
                                                        <option value="CAMPO">CAMPO</option>
                                                        <option value="">Volver...</option>
                                                    </Input>
                                                    <Input
                                                        type="text"
                                                        className="form-control flex-grow-1"
                                                        style={commonInputStyle}
                                                        placeholder="Ingrese DNI"
                                                        value={dniRow.value}
                                                        onChange={(e) => {
                                                            const val = e.target.value.replace(/\D/g, '').slice(0, 8);
                                                            handleDniChange(index, 'value', val);
                                                        }}
                                                        autoFocus
                                                        disabled={!canEditDni}
                                                    />
                                                </div>
                                            )}
                                        </div>

                                        {(!isAnalista && perfilIdNum !== 3) && (
                                            <div>
                                                <Input
                                                    type="select"
                                                    className="form-control"
                                                    style={commonInputStyle}
                                                    value={dniRow.revision_subgerencia}
                                                    onChange={(e) => handleDniChange(index, 'revision_subgerencia', Number(e.target.value))}
                                                    disabled={!canEditRevision}
                                                >
                                                    <option value={0}>Pendiente</option>
                                                    <option value={1}>Validar</option>
                                                    <option value={2}>Observar</option>
                                                </Input>
                                            </div>
                                        )}

                                        <div style={{ textAlign: 'right', display: 'flex', justifyContent: 'center' }}>
                                            {canEditDni && <ButtonDelete onClick={() => removeDniRow(index)} />}
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </FormGroup>

                        {isEditor && (
                            <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '25px' }}>
                                <Button
                                    className="button-custom"
                                    onClick={handleSave}
                                    disabled={loading}
                                >
                                    {loading ? 'REGISTRANDO...' : 'REGISTRAR'}
                                </Button>
                            </div>
                        )}
                    </Form>
                </ModalBody>
            </div>
        </Modal>
    );
}

export default ModalSeguimientoBoleta;